import "./MessageInputKit.css";
import { FiMic, FiTrash2 } from "react-icons/fi";
import SendBoldIcon from "../../icons/SendBoldIcon";

export default function MessageInputKit() {
  return (
    <section className="ui-kit-section">
      <h2 className="ui-kit-title">Message input</h2>

      <div className="miGrid">
        {/* Default */}
        <div className="miRow">
          <div className="miLabel">
            <div className="miLabelTitle">Default</div>
          </div>

          <MessageInputPreview
            state="default"
            placeholder="Write your message"
            right={<FiMic />}
          />
        </div>

        {/* Focus */}
        <div className="miRow">
          <div className="miLabel">
            <div className="miLabelTitle">Focus</div>
          </div>

          <MessageInputPreview
            state="focus"
            placeholder="Write your message"
            right={<SendBoldIcon />}
          />
        </div>

        {/* Transcription */}
        <div className="miRow">
          <div className="miLabel">
            <div className="miLabelTitle">Transcription</div>
            <div className="miLabelSub">Чат транскрибує повідомлення</div>
          </div>

          <RecordingPreview text="Transcription" loading />
        </div>

        {/* Recording (finger on container / delete) */}
        <div className="miRow">
          <div className="miLabel">
            <div className="miLabelTitle">Recording message</div>
            <div className="miLabelSub">Палець на контейнері запису</div>
          </div>

          <RecordingPreview text="Let go to delete" right={<FiTrash2 />} danger />
        </div>
      </div>
    </section>
  );
}

function MessageInputPreview({ state, placeholder, right }) {
  const cls = ["miInput", state === "focus" ? "isFocus" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls}>
      <div className="miField">
        <input placeholder={placeholder} readOnly />
      </div>

      <button className="miRightBtn" type="button" aria-label="action">
        <span className="miRightIcon">{right}</span>
      </button>
    </div>
  );
}

function RecordingPreview({ text, right, loading = false, danger = false }) {
  return (
    <div className={`miInput miRecording ${danger ? "isDanger" : ""}`}>
      <div className="miWave" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
        <i />
      </div>

      <div className="miRecText">{text}</div>

      {/* ✅ якщо loading — кнопки немає, тільки спінер */}
      {!loading && right && (
        <button className="miRightBtn" type="button" aria-label="action">
          <span className="miRightIcon">{right}</span>
        </button>
      )}

      {loading && <div className="miSpinner" aria-hidden="true" />}
    </div>
  );
}
